import styled, { css } from 'foundations-theming-specialty/utils';
import { useTranslation } from '../../hooks/useNavConfig';
import { MenuItemButton } from '../Menu';
import { useAppDispatch } from '../../hooks';
import { setDisplayFeedbackModal } from '../../reducers/AppConfig';
import { FEEDBACK_MODAL_REDESIGN_GENERAL_FEEDBACK } from '../FeedbackModal/constants';
import { useCallback } from 'react';
import { FeedbackIcon } from '../icons/FeedbackIcon';
import { getTypographyStyles } from 'breadcrumbs-ui/components/Text';
import { getAccountMenuItemPadding, getAccountMenuBorder } from './shared-styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledMenuItem = styled(MenuItemButton)(({
  theme
}) => css(["list-style-type:none !important;border-bottom:", " !important;position:relative;button,a{color:", " !important;position:relative;background-color:transparent;max-width:290px;", " border:0;margin:0;width:100%;padding:", " !important;display:flex;text-decoration:none;text-align:left;align-items:center;span{color:", " !important;margin-left:", " !important;font-size:14px !important;}&:hover,&:focus{text-decoration:underline !important;}svg{fill:", " !important;}}"], getAccountMenuBorder(theme), theme.color['text-core-default'], getTypographyStyles(theme, 'body-125'), getAccountMenuItemPadding(theme), theme.color['text-core-default'], theme.space[200], theme.color['icon-core-subtle']));
const RedesignedNavFeedback = () => {
  const dispatch = useAppDispatch();
  const {
    t
  } = useTranslation();
  const text = t('nav.accountMenu.shareNavFeedback');
  const updateOptinState = useCallback(() => {
    dispatch(setDisplayFeedbackModal({
      displayFeedbackModal: FEEDBACK_MODAL_REDESIGN_GENERAL_FEEDBACK
    }));
  }, [dispatch]);
  return /*#__PURE__*/_jsxs(StyledMenuItem, {
    id: "hs-accounts-optin-out",
    onClick: updateOptinState,
    "data-test-id": "redesigned-nav-toggle",
    children: [/*#__PURE__*/_jsx(FeedbackIcon, {}), /*#__PURE__*/_jsx("span", {
      children: text
    })]
  });
};
export default RedesignedNavFeedback;